import { useEffect } from 'react';
import SocketService from './socket.js';

export function useScreenStateUpdates(screenType, statsData, customPreview = {}) {
  useEffect(() => {
    const pairedScreenId = localStorage.getItem('pairedScreenId');
    
    if (!pairedScreenId || !SocketService.socket || !SocketService.socket.connected) {
      return;
    }

    // Default preview data per screen type
    const previewData = {
      data: {
        type: 'data',
        backgroundColor: 'linear-gradient(135deg, #001122 0%, #003366 100%)',
        title: '📊 Data Visualization Hub'
      },
      solutions: {
        type: 'solutions',
        backgroundColor: 'linear-gradient(135deg, #00b894 0%, #00a085 100%)',
        title: '💡 Solutions Explorer'
      },
      futures: {
        type: 'futures',
        backgroundColor: 'linear-gradient(135deg, #6c5ce7 0%, #5f3dc4 100%)',
        title: '🔮 Future Scenarios'
      },
      table: {
        type: 'table',
        backgroundColor: 'linear-gradient(135deg, #fd79a8 0%, #e84393 100%)',
        title: '🎲 3D Table Experience'
      }
    };

    const updateInterval = setInterval(() => {
      if (SocketService.socket && SocketService.socket.connected) {
        SocketService.socket.emit('screen-state-update', {
          screenId: pairedScreenId,
          view: screenType,
          stats: statsData,
          preview: {
            ...previewData[screenType],
            ...customPreview
          }
        });
      }
    }, 2000);

    return () => clearInterval(updateInterval);
  }, [screenType, statsData, customPreview]);
}